import { Dropdown, Typography } from "@hmsexp/component-library";
import React from "react";
import { View } from "../../../../../../components/Common/react-native-components";
import { REVIEW_RATING_BY_SITE_OPTIONS } from "../../../../constants";
import { dropdownStyling } from "../../styles";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts"
import { reviewRatingStyling } from './style';

const BarGraphView = ({
    selectedMetrix,
    setSelectedMetrix,
    barChartData,
    color,
    chartRef
}) => {
    const styles = reviewRatingStyling();
    return (
        <>
            <Typography
                textProps={{ style: { marginBottom: 5 } }}
                variant='button'
                color='primaryContentMedium'
                fontWeightType='regular'>
                Question
            </Typography>

            <View style={{ maxWidth: 200 }}>
                <Dropdown
                    items={REVIEW_RATING_BY_SITE_OPTIONS}
                    onChange={setSelectedMetrix}
                    value={selectedMetrix}
                    label={''}
                    style={{
                        container: {
                            ...dropdownStyling.container
                        },
                        optionContainer: dropdownStyling.optionContainer,
                        dropDownText: dropdownStyling.dropDownText,
                        icon: dropdownStyling.icon
                    }}
                />
            </View>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={barChartData} />
            <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={{ flexDirection: 'row' }}>
                    <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                        <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                        <Typography fontWeightType='regular' variant='button'>
                            {selectedMetrix}
                        </Typography>
                    </View>
                </View>
            </View>
        </>
    );
};

export default BarGraphView